import { GET_INVITATIONS_SENT_COUNT } from "@graphql"
import { useQuery } from "@apollo/client"

const useInvitationsSentCount = (eventId) => {
  const {data, loading, error} = useQuery(GET_INVITATIONS_SENT_COUNT, {
    fetchPolicy: "network-only",
    variables: { id: eventId }
  })

  return {
    data,
    loading,
    error,
  }
}

export default useInvitationsSentCount